module.exports = "<main class=\"advert-stripe\">\n\t<article>\n\t\t<h2 style=\"text-align:center; color: #989898\">Услуга недоступна</h2>\t\t\n\t</article>\n</main>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/noservice/noservice.template.html
 ** module id = 1006
 ** module chunks = 1
 **/